import React from 'react';
import { Button, Checkbox, Col, Icon, message, Row, Spin, Table, Tag } from 'antd';
import 'styles/case-listing.css';
import { CaseService } from '../../services';
import { Map } from 'immutable';
import { BASE_URL } from '../../constants';
import ConfirmButton from '../../components/confirm-button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const columns = [
    {
        title: "Case ID",
        dataIndex: "id",
        render: id => <a href={`${process.env.SOUL_BASE_URL}/app/case/${id}`} target="_blank">{id}</a>,
        width:130,
    },
    {
        title: "Status", 
        dataIndex: "cam_data", 
        render: (cam_data) => {
            if (cam_data?.approved_by && !cam_data?.rejected_by) {
                return <Tag color="green">Approved</Tag>;
            }

            if (!cam_data?.approved_by && cam_data?.rejected_by) {
                return <Tag color="red">Rejected</Tag>;
            }

            return <Tag color="orange">Pending</Tag>;
        },
        width: 100,
    },
    {
        title: "Buyer Name",
        dataIndex: "company_name",
        width: 150,
    },
    {
        title: "Seller Name", dataIndex: "sellers",
        render: sellers =>
            sellers?.map(item => item.name).join(", "),
        width:250,
    },
    {
        title: "Anchor Name", dataIndex: "anchors", render: anchors =>
            anchors?.map(item => item.name).join(", "),
        width : 250
    },

    { title: "Lender", dataIndex: "bank.code", render: (_) => _ || '-' , width:120,},
    { title: "Proposed Limit", dataIndex: "proposed_limit" ,width: 100},
    { title: "Existing Limits", dataIndex: "existing", render: _ => '-' , width:140,},
    {
        title: "ROI / Tenure", render: (_, record) => (
            record.min_normal_roi ? <>
                {record.min_normal_roi} / {record.tenure}
            </> : "-"
        ),
        width:140,
    },
    { title: "BV (Yrs)", dataIndex: "cam_data.business_vintage", render: _ => _ ? (_ / 12).toFixed(2) : '-' , width:100,},
    { title: "City", dataIndex: "city", render: (_) => _ || '-' , width:130,},
    { title: "State", dataIndex: "state", render: (_) => _ || '-' , width:130,},
    { title: "Industry", dataIndex: "industry_name" , width:130,},
    {
        title: "Deviations",
        dataIndex: "cam_data.deviations",
        width: 300,
        render: (deviations) => (
            <>
                {deviations ? deviations.map((item, index) => (
                    <div style={{
                        display: 'inline-block',
                        padding: '2px 6px',
                        margin: '4px',
                        border: `1px solid ${item.color}`,
                        borderRadius: '3px',
                        backgroundColor: item.color,
                        fontSize: '8px',
                        fontWeight: 500

                    }} key={index}>{item['label']}</div>
                )) : '-'}
            </>
        ),
    },
];
 class FoundersCaseListing extends React.Component {

    state = {
        caseListingDetails: Map(),
        totalProposedLimit: 0,
        selectedRowKeys: [],

    }

    componentDidMount() {
        const caseIds = this.getCaseIdsFromQuery();
        this.caseListingUpdate(caseIds)
    }


    getCaseIdsFromQuery = () => {
        const params = new URLSearchParams(this.props.location.search);
        const caseIdsStr = params.get("case_ids"); // "141115,141202,142742"
        if (!caseIdsStr) return [];

        return caseIdsStr.split(",").map(id => Number(id));
    };

    caseListingUpdate = (caseIds) => {
        CaseService.getCaseListingData(caseIds)
            .then(({ data }) => {
                this.setState({
                    caseListingDetails: Map(data),
                    totalProposedLimit: data['data'].reduce((total, item) => {
                        return (parseFloat(item.proposed_limit) || 0.0) + total
                    }, 0)
                })
            })
    }


     approveSelectedCases = () => {
        if (this.props.user && ['pallavi@progcap.com', 'himanshu@progcap.com'].includes(this.props.user.getIn(['data', 'email']))) {
             CaseService.caseBulkApproveRejectByCaseApprover(this.state.selectedRowKeys, "Approved", "P")
                 .then(({ data }) => {
                     const caseIds = this.getCaseIdsFromQuery();
                     this.showMessage(data.results);
                     this.caseListingUpdate(caseIds);
                     this.setState({
                         selectedRowKeys: []
                     })
                 })
                 .catch(() => {
                     message.error("Something Went Wrong");
                 });
         } else {
            message.error("You don’t have the required permissions to approve or reject this request. Please contact the system admin if you believe this is incorrect.")
         }

     }

     rejectSelectedCases = (remarks) => {
         if (this.props.user && ['pallavi@progcap.com', 'himanshu@progcap.com'].includes(this.props.user.getIn(['data', 'email']))) {
             CaseService.caseBulkApproveRejectByCaseApprover(this.state.selectedRowKeys, "Rejected", "P")
                 .then(({ data }) => {
                     const caseIds = this.getCaseIdsFromQuery();
                     this.showMessage(data.results);
                     this.caseListingUpdate(caseIds);
                     this.setState({
                         selectedRowKeys: []
                     })
                 })
                 .catch(() => {
                     message.error("Something Went Wrong");
                 });
         }
         else {
             message.error("You don’t have the required permissions to approve or reject this request. Please contact the system admin if you believe this is incorrect.")
         }
     }


    showMessage = (results) => {
        const approved = [];
        const rejected = []
        const alreadyRejected = [];
        const noRecord = [];
        const alreadyApproved = []
        results.forEach(item => {
            if (item.status === "Approved") {
                approved.push(item.case_id);
            }
            if (item.status === "Rejected") {
                rejected.push(item.case_id);
            }

            else if (item.status === "Already Rejected") {
                alreadyRejected.push(item.case_id);
            }
            else if (item.status === "No approval record found") {
                noRecord.push(item.case_id);
            } else if (item.status === "Already Approved") {
                alreadyApproved.push(item.case_id);
            }
        });

        const summary = (
            <div>
                {approved.length > 0 && (
                    <div>✅ Approved: {approved.join(", ")}</div>
                )}
                {rejected.length > 0 && (
                    <div>✅ Rejected: {rejected.join(", ")}</div>
                )}

                {alreadyRejected.length > 0 && (
                    <div style={{ marginTop: 6 }}>
                        ⚠️ Already Rejected: {alreadyRejected.join(", ")}
                    </div>
                )}
                {alreadyApproved.length > 0 && (
                    <div style={{ marginTop: 6 }}>
                        ⚠️ Already Approved: {alreadyApproved.join(", ")}
                    </div>
                )}

                {noRecord.length > 0 && (
                    <div style={{ marginTop: 6 }}>
                        ❌ No approval record found: {noRecord.join(", ")}
                    </div>
                )}
            </div>
        );

        message.info(summary, 6);
    };


    render() {
        const rowSelection = {
            selectedRowKeys: this.state.selectedRowKeys,

            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({ selectedRowKeys });
            },

            getCheckboxProps: record => ({
                disabled: record.cam_data.approved_by != null && record.cam_data.rejected_by == null,
            }),
        };

        const { totalProposedLimit, selectedRowKeys } = this.state;
        return (
            <div className="case-listing">
                <Spin spinning={!this.state.caseListingDetails.size}>
                    <Row gutter={16}>
                        <Col xs={24} sm={6} className='mb-10'>
                            <div className="summary-card total-cases">
                                <div className='d-flex align-items-center'>
                                    <div className="icon">
                                        📈
                                    </div>
                                    <div>
                                        <h3 className="label ml-10 mb-0">Total Cases</h3>

                                        <h4 className="value ml-10">{this.state.caseListingDetails.size && this.state.caseListingDetails.get('data').length}</h4>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={24} sm={6} className='mb-10'>
                            <div className="summary-card total-limit">
                                <div className='d-flex align-items-center'>
                                    <div className="icon">
                                        ₹
                                    </div>
                                    <div >
                                        <h3 className="label ml-10 mb-0">Total Limit</h3>
                                        <h4 className="value ml-10">{totalProposedLimit ? '₹ ' + ((totalProposedLimit / 10000000).toFixed(3) + ' Cr') : '-'}</h4>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} sm={6} className='mb-10'>
                            <div className="summary-card total-limit">
                                <div className='d-flex align-items-center'>
                                    <div className="icon">
                                        ⚠️
                                    </div>
                                    <div >
                                        <h3 className="label ml-10 mb-0">Deviation</h3>
                                        <h4 className="value ml-10">{
                                            this.state.caseListingDetails.size
                                                ? this.state.caseListingDetails
                                                    .get('data')
                                                    .filter(
                                                        item =>
                                                            Array.isArray(item?.cam_data?.deviations) &&
                                                            item.cam_data.deviations.length > 0
                                                    ).length
                                                : '-'
                                        }</h4>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <div className="cases-table">
                            {/* Header */}
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <h3>
                                        Cases Overview{" "}
                                        <span className="subtitle">
                                            — Click on Case ID to view detailed CAM information
                                        </span>
                                    </h3>
                                </Col>
                                {(this.props.user && ['pallavi@progcap.com', 'himanshu@progcap.com'].includes(this.props.user.getIn(['data', 'email']))) && <Col>
                                    {selectedRowKeys.length ? <span className='mr-10 font_14' >{selectedRowKeys.length} Selected</span> : <></>}
                                    <ConfirmButton
                                        label={"Approve"}
                                        class={selectedRowKeys.length ? "btn-approve mr-10 " : "btn-approve disabled-look mr-10"}
                                        description={`Do you confirm approval of ${selectedRowKeys.length} selected cases?`}
                                        onConfirm={() => this.approveSelectedCases()}
                                        type=""
                                        icon="check"
                                    />
                                    <ConfirmButton
                                        label={"Reject"}
                                        class={selectedRowKeys.length ? "refer-back" : "refer-back disabled-look"}
                                        description={`Do you confirm rejection of ${selectedRowKeys.length} selected cases?`}
                                        onConfirm={(remarks) => this.rejectSelectedCases(remarks)}
                                        type=""
                                        icon="check"
                                        showRemarks
                                    />
                                    {/* <Button icon="undo" disabled={!selectedRowKeys.length} className={selectedRowKeys.length ? "refer-back" : "refer-back disabled-look"} style={{ marginLeft: 8 }}>
                                        Refer Back
                                    </Button> */}
                                </Col>}
                            </Row>

                            {/* Legend */}
                            <div className="legend">
                                <span className='legend-heading'>Deviations' Legend:</span>
                                <Tag color="#2BD2F3">General</Tag>
                                <Tag color="#2EEFC8">Ledger</Tag>
                                <Tag color="#CAD2F2">GST</Tag>
                                <Tag color="#FCDBBF">Bank</Tag>
                                <Tag color="#F8FAC1">Bureau</Tag>
                                <Tag color="#FEE1FC">Financials</Tag>
                                <Tag color="#FECDE6">Anchor</Tag>
                            </div>

                            <Table
                                className='table-layout-fix'
                                columns={columns}
                                rowSelection={rowSelection}
                                rowKey={'id'}
                                dataSource={this.state.caseListingDetails.get('data')}
                                pagination={false}
                                scroll={{ x: 'max-content' }}
                                rowClassName={record => {
                                    const count = record && record.cam_data && record.cam_data.deviations?.length || 0;
                                    if (count > 8) return "row-dev-high";
                                    if (count > 4) return "row-dev-medium";
                                    if (count > 0) return "row-dev-low";
                                    return "row-dev-none";
                                }}

                            />
                        </div>
                    </Row>
                </Spin>
            </div>
        )
    }
}

FoundersCaseListing.defaultProps = {
};

FoundersCaseListing.propTypes = {
    user: PropTypes.object,
    userStatus: PropTypes.string,
};

const mapStateToProps = (
    state,
) => {
    return {
        user: state.user,
        userGroups: state.user && state.user.getIn(["data", "groups"]).map(_ => _.id),
        userStatus: state.user.get("status"),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {},
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FoundersCaseListing);
